import type { ArticleCard } from 'types/capi/shared';

import ChevronIcon from '~/assets/icons/Chevron';

export type MetadataSize = 'sm' | 'md' | 'lg';
export type MetadataTheme = 'light' | 'dark';

type Props = {
  expanded?: boolean;
  isTextOverImage?: boolean;
  item: ArticleCard;
  oneLineTitle?: boolean;
  size: MetadataSize;
  theme: MetadataTheme;
};

const TITLE_CLASSES: Record<MetadataSize, string> = {
  lg: 'text-card-lg',
  md: 'text-card-md',
  sm: 'text-card-sm'
};

const READ_LABEL: Record<MetadataTheme, string> = {
  dark: 'Read more',
  light: 'Read article'
};

export default function Metadata({
  expanded,
  isTextOverImage = false,
  item,
  oneLineTitle,
  size,
  theme
}: Props) {
  const titleClass = TITLE_CLASSES[size];
  const titleColor = theme === 'dark' ? 'text-white' : 'text-black';
  const excerptColor = theme === 'dark' ? 'text-white' : 'text-grey-hide';
  const nudge = size === 'sm' ? '' : 'mt-1';
  const ctaColour = isTextOverImage ? 'text-white' : 'text-grey-hide';

  return (
    <>
      <div className="flex flex-col gap-1">
        <h4 className="text-start text-xs text-grey-hide">
          {item.section ?? 'Article'}
        </h4>
        <h3
          className={`text-start ${titleClass} ${titleColor} ${
            oneLineTitle
              ? 'line-clamp-1'
              : expanded
                ? 'line-clamp-3' // to make room for excerpt
                : 'line-clamp-4'
          }`}
        >
          {item.title}
        </h3>
      </div>

      {expanded && item.excerpt && (
        <p className={`${nudge} line-clamp-4 text-sm ${excerptColor}`}>
          {item.excerpt}
        </p>
      )}

      <div
        className={`${nudge} flex flex-row items-center gap-2 text-nowrap text-sm ${ctaColour}`}
      >
        <p className="leading-none">{READ_LABEL[theme]}</p>
        <div className="flex rotate-270 items-center justify-center">
          <ChevronIcon stroke="#A9A9A9" width="8px" height="8px" />
        </div>
      </div>
    </>
  );
}
